import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';



export function* getAnalytics() {
    yield takeEvery(actions.FETCH_ANALYTICS_REQUESTED, function* (action) {
        try {
            const statistics = yield call(actions.getAnalytics, action.payload);
            yield put({ type: actions.FETCH_ANALYTICS_SUCCEEDED, statistics });
        } catch (error) {
            yield put({ type: actions.FETCH_ANALYTICS_FAILED, error: error.message });
        }
    });
}

export function* getTotalRevenue() {
    yield takeEvery(actions.FETCH_TOTAL_REVENUE_REQUESTED, function* (action) {
        try {
            const statistics = yield call(actions.getAnalytics, {totalRevenue: action.payload});
            yield put({ type: actions.FETCH_ANALYTICS_SUCCEEDED, statistics });
        } catch (error) {
            yield put({ type: actions.FETCH_ANALYTICS_FAILED, error: error.message });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(getAnalytics),
        fork(getTotalRevenue)
    ]);
}
